<template>
  <v-dialog
    v-model="dialog"
    :max-width="width"
    persistent
  >
    <v-card>
      <v-toolbar color="primary" dark flat short class="px-2">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon><v-icon>fas fa-times</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="mt-12">
        <slot name="content">{{ content }}</slot>
      </v-card-text>

      <v-card-actions class="px-6 pb-8">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="px-5"
          large
          depressed
          @click="close()"
        >Close</v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>

</template>

<script>
import { ref, watch } from 'vue'

export default {
  components: {
  },
  props: {
    value: Boolean,
    width: {
      type: [String, Number],
      default: 600,
    },
    title: String,
    content: String,
  },
  setup(props, context) {
    
    const dialog = ref(props.value)

    watch(() => props.value, val => {
      dialog.value = val
    })

    watch(dialog, val => {
      context.emit('input', val)
    })

    function close() {
      dialog.value = false
    }

    return {
      dialog,
      close,
    }

  }

}

</script>

